import { render } from "./SudokuNumber.vue?vue&type=template&id=6b3c831e&scoped=true"
import script from "./SudokuNumber.vue?vue&type=script&lang=js"
export * from "./SudokuNumber.vue?vue&type=script&lang=js"

import "./SudokuNumber.vue?vue&type=style&index=0&id=6b3c831e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3c831e"]])

export default __exports__